export const validatePassword = (_: any, value: string) => {
	if (!value) {
		Promise.resolve();
		return Promise.reject(new Error('Please enter password.'));
	}
	// if (value.length < 4 || value.length > 16) {
	// 	Promise.resolve();
	// 	return Promise.reject(new Error('Password must be 4-16 characters.'));
	// }
	// if (!/(?=.*\d)/.test(value)) {
	// 	Promise.resolve();
	// 	return Promise.reject(new Error('Must include at least one digit.'));
	// }
	// if (!/(?=.*[!@#$%^&*?]+)/.test(value)) {
	// 	Promise.resolve();
	// 	return Promise.reject(new Error('Include at least one special character.'));
	// }
	// if (!/(?=.*[A-Z])/.test(value)) {
	// 	Promise.resolve();
	// 	return Promise.reject(new Error('Add at least one uppercase letter.'));
	// }
	// if (!/(?=.*[a-z])/.test(value)) {
	// 	Promise.resolve();
	// 	return Promise.reject(new Error('Add at least one lowercase letter.'));
	// }
	return Promise.resolve();
};


const escapeCSVValue = (value: any) => {
	if (value === null || value === undefined) {
		return '-';
	}
	let stringValue = String(value);
	if (stringValue.includes(',') || stringValue.includes('\n') || stringValue.includes('"')) {
		stringValue = `"${stringValue.replace(/"/g, '""')}"`;
	}
	return stringValue;
};

export const convertToCSV = (data: any[]) => {
	const headers = Object.keys(data[0]).join(',') + '\n';
	const rows = data?.map((row) => Object.values(row)?.map(escapeCSVValue).join(',')).join('\n');
	return headers + rows;
};

export const downloadCSV = (csvData: string, fileName: string) => {
	const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
	const link = document.createElement('a');
	const url = URL.createObjectURL(blob);
	link.setAttribute('href', url);
	link.setAttribute('download', `${fileName}.csv`);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};
